var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 60,
    viewBox: "0 0 66 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6665 60C52.235 60 65.6665 46.5685 65.6665 30C65.6665 13.4315 52.235 0 35.6665 0C19.098 0 5.6665 13.4315 5.6665 30C5.6665 46.5685 19.098 60 35.6665 60Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2461 29.6834C27.9917 25.8731 33.8234 23.3611 36.7414 22.1474C45.0727 18.6821 46.8039 18.0801 47.9322 18.0603C48.1804 18.0559 48.7353 18.1174 49.0947 18.4091C49.3982 18.6553 49.4817 18.988 49.5217 19.2215C49.5617 19.455 49.6114 19.9869 49.5719 20.4025C49.1204 25.1462 47.1669 36.6579 46.173 41.971C45.7525 44.2191 44.9244 44.9729 44.1228 45.0467C42.3806 45.207 41.0577 43.8953 39.3704 42.7893C36.73 41.0584 35.2383 39.981 32.6754 38.2921C29.7134 36.3402 31.6335 35.2674 33.3215 33.5142C33.7633 33.0553 41.4393 26.0734 41.5878 25.4401C41.6064 25.3609 41.6236 25.0656 41.4482 24.9097C41.2728 24.7538 41.0139 24.8071 40.8271 24.8495C40.5623 24.9096 36.3442 27.6976 28.1729 33.2134C26.9756 34.0356 25.8912 34.4361 24.9195 34.4152C23.8484 34.392 21.7879 33.8095 20.2562 33.3116C18.3774 32.7009 16.8842 32.378 17.0142 31.3408C17.082 30.8006 17.8259 30.2481 19.2461 29.6834Z",
    fill: "url(#paint0_linear_1699_12143)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1699_12143",
    x1: 1646.01,
    y1: 18.0601,
    x2: 1646.01,
    y2: 2698.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.ba7f3755f9bf8510f8d418b38ef48e69.svg";
export { ForwardRef as ReactComponent };